import React, { useEffect, useRef, useState } from 'react';
import Button from 'shared/components/Button';
import { ArrowLeftIcon, TimesIcon } from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { saveToStore } from 'utils/storeHelpers';
import { isMobileSize } from 'shared/utils/appHelpers';

const OnBoardModal = ({ className, content, onClose, type, onCloseHandler }) => {
  const { t } = useTranslation();
  const modalEl = useRef();
  const [activeStep, setActiveStep] = useState(1);
  const stepsArr = new Array(content.length).fill(0);
  const selectedStep = content[activeStep - 1];
  const isLastStep = stepsArr.length === activeStep;
  const isMobile = isMobileSize(window.innerWidth);

  const onSkip = () => {
    removeBlurElements();
    saveToStore(type, true);
    onClose();
    onCloseHandler && onCloseHandler();
  };

  const handleNextClick = () => {
    if (isLastStep) {
      onSkip();
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const setBlurElements = elements => {
    elements?.forEach(sel => {
      document.querySelectorAll(sel)?.forEach(el => {
        el.classList.add('onboard-blur');
      });
    });
  };

  const removeBlurElements = () => {
    document.querySelectorAll('.onboard-blur')?.forEach(el => {
      el.classList.remove('onboard-blur');
    });
  };

  const setPosition = () => {
    removeBlurElements();
    setBlurElements(selectedStep.filterEls);

    const selElement = isMobile ? selectedStep.elMobile || selectedStep.el : selectedStep.el;
    if (!selElement) {
      if (isMobile) {
        modalEl.current.style.top = `80px`;
      }
      return;
    }
    const selector = document.querySelector(selElement);
    if (!selector) return;
    const coordinated = selector.getBoundingClientRect();

    if (selectedStep.position === 'left') {
      modalEl.current.style.right = `${window.innerWidth - coordinated.right + coordinated.width + 80}px`;
      modalEl.current.style.top = `${Number(coordinated.top) -
        Number(modalEl.current.offsetHeight / 2) +
        coordinated.height -
        20}px`;
    }

    if (selectedStep.position === 'bottom') {
      modalEl.current.style.left = `${coordinated.left + 15}px`;
      modalEl.current.style.top = `${Number(coordinated.top) + Number(coordinated.height) + 10}px`;
    }

    if (isMobile) {
      modalEl.current.style.left = 0;
    }
  };

  useEffect(() => {
    setTimeout(setPosition);
  }, [selectedStep]);

  return (
    <div
      ref={modalEl}
      className={`onboard-modal d-flex flex-column justify-content-between mx-8 ${
        selectedStep?.el ? 'has-arrow' : ''
      } arrow-${selectedStep.position} ${selectedStep?.className || ''} ${className || ''}`}
    >
      <button className='btn p-0 modal-close' onClick={onSkip}>
        <TimesIcon />
      </button>
      <div className='px-md-15 px-8 pt-15 pb-10'>{selectedStep?.component}</div>
      <div className='d-flex align-items-center justify-content-between px-8 px-md-15 py-md-10 py-8 border-top'>
        <div className='onboard-steps d-flex align-items-center'>
          {stepsArr.map((item, i) => {
            const isActive = i + 1 === activeStep;
            return <span key={i} className={`step mr-4 ${isActive ? 'active' : ''}`} />;
          })}
        </div>
        <div className='d-flex align-items-center'>
          <Button type='button' className={'btn-sm text-primary py-3'} onClick={onSkip}>
            {t('btn_skip')}
          </Button>
          <Button
            type='button'
            onClick={handleNextClick}
            className={
              'btn-sm ml-md-12 ml-6 btn-primary btn-primary-with-icon rounded-25 py-3 pr-4 d-flex align-items-center'
            }
          >
            {t('btn_next')}
            <span className='ml-8 d-flex align-items-center justify-content-center'>
              <ArrowLeftIcon width='20' height='20' className='rotate-180 swg-white' />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnBoardModal;
